module.exports = __webpack_public_path__ + "img/CHECK.4003f360.svg";